import { useRef, useState, useEffect } from "react";
import styles from "./nadi.module.css"; // Import CSS module

const Nadi = ({ setAns, ans, handleInputChange }) => {
  const scrollableDivRef = useRef(null);
  const [scrollValue, setScrollValue] = useState(0);
  const [maxScroll, setMaxScroll] = useState(0);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (scrollableDivRef.current) {
      setMaxScroll(scrollableDivRef.current.scrollWidth - scrollableDivRef.current.clientWidth);
    }

    return () => {
      setAns((val) => ({ ...val, ...formData }));
      
    }
  }, []);

  const handleScroll = (event) => {
    const newScrollValue = event.target.value;
    setScrollValue(newScrollValue);
    if (scrollableDivRef.current) {
      scrollableDivRef.current.scrollLeft = (maxScroll * newScrollValue) / 100;
    }
  };
   const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    
  
  };

  useEffect(() => {
    setAns((val) => ({ ...val, ...formData }));
  }, [formData])

  return (
    <div className={styles.container} ref={scrollableDivRef}>
        <div className={styles.header}>
            <div className={styles.headercontent}>Right Hand : Males
            </div>
            <div className={styles.headercontent}>Left Hand : Females
            </div>
        </div>
        <div className={styles.sec2}>
        <div className={styles.table}>
      
      <div className={styles.column}>
        <div className={styles.theader}>1</div>
        <div className={styles.cell}>Prakruti</div>
      </div>

     
      {["V", "P", "K"].map((col, index) => (
        <div className={styles.column} key={index}>
          <div className={styles.theader}>{col}</div>
          <input name={`prakruti_${col}_1`} type="text"value={ans[`prakruti_${col}_1`] || ""} onChange={handleChange}  className={styles.inputBox} />
          <input name={`prakruti_${col}_2`} type="text"value={ans[`prakruti_${col}_2`] || ""} onChange={handleChange} className={styles.inputBox} />
          <input name={`prakruti_${col}_3`}  type="text"value={ans[`prakruti_${col}_3`] || ""} onChange={handleChange} className={styles.inputBox} />
        </div>
      ))}
    </div>
    <div className={styles.table}>
      
      <div className={styles.column}>
        <div className={styles.theader}>2</div>
        <div className={styles.cell}>Vikruti</div>
      </div>

     
      {["V", "P", "K"].map((col, index) => (
        <div className={styles.column} key={index}>
          <div className={styles.theader}>{col}</div>
          <input name={`vikruti_${col}_1`}type="text"   value={ans[`vikruti_${col}_1`] || ""} onChange={handleChange} className={styles.inputBox} />
          <input name={`vikruti_${col}_2`} type="text"   value={ans[`vikruti_${col}_2`] || ""} onChange={handleChange} className={styles.inputBox} />
          <input name={`vikruti_${col}_3`} type="text"   value={ans[`vikruti_${col}_3`] || ""} onChange={handleChange} className={styles.inputBox} />
        </div>
      ))}
    </div>
        </div>
        <div className={styles.sec3}>
        <div className={styles.table2}>
      
      <div className={styles.column2}>
        <div className={styles.theader}>3</div>
        <div className={styles.cell}>Gati</div>
        <div className={styles.cell}></div>
        <div className={styles.cell}></div>

        <div className={styles.cell}>Dosha</div>
      </div>

     
      {["Li", "Gb", "Pe","Si", "St", "Ub"].map((col, index) => (
        <div className={styles.column2} key={index}>
          <div className={styles.theader}>{col}</div>
          <input name={`${col}_1`} type="text"value={ans[`${col}_1`] || ""}   onChange={handleChange} className={styles.inputBox} />
          <input name={`${col}_2`} type="text" value={ans[`${col}_2`] || ""}  onChange={handleChange} className={styles.inputBox} />
          <input name={`${col}_3`} type="text" value={ans[`${col}_3`] || ""} onChange={handleChange}  className={styles.inputBox} />
          
        </div>
      ))}
      
    </div>
    <div
  className={styles.table2}
 
>

      
      <div className={styles.column2}>
        <div className={styles.theader}>4</div>
        <div className={styles.cell}>Gati</div>
        <div className={styles.cell}></div>
        <div className={styles.cell}></div>

        <div className={styles.cell}>Dosha</div>
      </div>

     
      {["Lu", "Liv", "PS","He", "Kl", "Ki"].map((col, index) => (
        <div className={styles.column2} key={index}>
          <div className={styles.theader}>{col}</div>
          <input name={`${col}_1`} type="text"value={ans[`${col}_1`] || ""}  onChange={handleChange} className={styles.inputBox} />
          <input name={`${col}_2`} type="text"value={ans[`${col}_2`] || ""}  onChange={handleChange} className={styles.inputBox} />
          <input name={`${col}_3`}type="text" value={ans[`${col}_3`] || ""}  onChange={handleChange} className={styles.inputBox} />
          
        </div>
      ))}
      
    </div>
    </div>
    <div className={styles.sec3}>
    <div className={styles.table2}>
      
      <div className={styles.column2}>
        <div className={styles.theader}>5</div>
        <div className={styles.cell}>Manas</div>
        

      </div>

     
      {["V", "P", "K"].map((col, index) => (
        <div className={styles.column2} key={index}>
          <div className={styles.theader}>{col}</div>
          <input name={`manas_${col}_1`}type="text"  value={ans[`manas_${col}_1`] || ""} onChange={handleChange} className={styles.inputBox} />
          <input name={`manas_${col}_2`} type="text" value={ans[`manas_${col}_2`] || ""}  onChange={handleChange} className={styles.inputBox} />
          <input name={`manas_${col}_3`} type="text"  value={ans[`manas_${col}_3`] || ""} onChange={handleChange} className={styles.inputBox} />
          
        </div>
      ))}
      
    </div>
    </div>
    <div className={styles.sec4}>
        <table className={styles.table3}>
        <thead>
          <tr>
            <th>6</th>
            <th>V</th>
            <th>P</th>
            <th>K</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.label}>Dosha:</td>
            <td>
              <div className={styles.cellGroup}>
                <span>Pr</span> 
                <span>Ap</span> 
              </div>
              <div className={styles.cellGroup2}>
                 <input name={`pr`}type="text"value={ans['pr'] || ""} onChange={handleChange}  className={styles.inputg} />
            <input name={`ap`}type="text"value={ans['ap'] || ""}  onChange={handleChange} className={styles.inputg} />
              </div>
              <div className={styles.cellGroup}>
                <span>Ud</span> 
                <span>Vy</span> 
                <span>Sa</span> 
              </div>
              <div className={styles.cellGroup}>
                <input name={`ud`}type="text" value={ans['ud'] || ""} onChange={handleChange} className={styles.inputg} />
                 <input name={`vy`}type="text" value={ans['vy'] || ""} onChange={handleChange} className={styles.inputg} />
                <input name={`sa_v`}type="text" value={ans['sa_v'] || ""} onChange={handleChange} className={styles.inputg} />
              </div>
            </td>
            <td>
              <div className={styles.cellGroup}>
                <span>Pa</span> 
                <span>Sa</span> 
              </div>
              <div className={styles.cellGroup2}>
                 <input name={`pa`}type="text"value={ans['pa'] || ""} onChange={handleChange}  className={styles.inputg} />
            <input name={`sa_p`}type="text" value={ans['sa_p'] || ""} onChange={handleChange} className={styles.inputg} />
              </div>
              <div className={styles.cellGroup}>
                <span>Ra</span> 
                <span>Bh</span> 
                <span>Al</span> 
              </div>
              <div className={styles.cellGroup}>
                <input name={`ra`}type="text" value={ans['ra'] || ""} onChange={handleChange} className={styles.inputg} />
                 <input name={`bh`}type="text" value={ans['bh'] || ""} onChange={handleChange} className={styles.inputg} />
                <input name={`al`}type="text" value={ans['al'] || ""} onChange={handleChange} className={styles.inputg} />
              </div>
            </td>
            <td>
              <div className={styles.cellGroup}>
                <span>Kh</span> 
                <span>Ta</span> 
              </div>
              <div className={styles.cellGroup2}>
                 <input name={`kh`}type="text"value={ans['kh'] || ""} onChange={handleChange}  className={styles.inputg} />
            <input name={`ta`}type="text" value={ans['ta'] || ""} onChange={handleChange} className={styles.inputg} />
              </div>
              <div className={styles.cellGroup}>
                <span>Av</span> 
                <span>Sh</span> 
                <span>Bo</span> 
              </div>
              <div className={styles.cellGroup}>
                <input name={`av`}type="text"value={ans['av'] || ""} onChange={handleChange}  className={styles.inputg} />
                 <input name={`sh`}type="text" value={ans['sh'] || ""} onChange={handleChange} className={styles.inputg} />
                <input name={`bo`}type="text"value={ans['bo'] || ""} onChange={handleChange}  className={styles.inputg} />
              </div>
            </td>
          </tr>
        </tbody>
        </table>
        <table className={styles.table3}>
        <thead>
          <tr>
            <th>7</th>
            <th>V</th>
            <th>P</th>
            <th>K</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.label}>Dhatu:</td>
            <td>
              <div className={styles.cellGroup}>
                <span>Majj</span> 
                <span>Asthi</span> 
              </div>
              <div className={styles.cellGroup2}>
                 <input name={`majj`}type="text"value={ans['majj'] || ""} onChange={handleChange}  className={styles.inputg} />
                 <input name={`asthi`}type="text" value={ans['asthi'] || ""} onChange={handleChange} className={styles.inputg} />
              </div>
              <div className={styles.cellGroup}>
                <span>Shu/Art</span>
              
              </div>
              <div className={styles.cellGroup}>
                <input name={`shu_art_v`}type="text"value={ans['shu_art_v'] || ""}  onChange={handleChange} className={styles.inputg} />
             
              </div>
            </td>
            <td>
              <div className={styles.cellGroup}>
                <span>Meda</span>
                <span>Mas</span> 
              </div>
              <div className={styles.cellGroup2}>
                 <input name={`meda`}type="text"value={ans['meda'] || ""}  onChange={handleChange} className={styles.inputg} />
                <input name={`mas`}type="text"value={ans['mas'] || ""}  onChange={handleChange} className={styles.inputg} />
              </div>
              <div className={styles.cellGroup}>
                <span>Shu/Art</span> 
               
              </div>
              <div className={styles.cellGroup}>
                <input name={`shu_art_p`}type="text" value={ans['shu_art_p'] || ""} onChange={handleChange} className={styles.inputg} />
            
              </div>
            </td>
            <td>
              <div className={styles.cellGroup}>
                <span>Rak</span> 
                <span>Ras</span> 
              </div>
              <div className={styles.cellGroup2}>
                 <input name={`rak`}type="text"value={ans['rak'] || ""}  onChange={handleChange} className={styles.inputg} />
                 <input name={`ras`} type="text"value={ans['ras'] || ""} onChange={handleChange} className={styles.inputg} />
              </div>
              <div className={styles.cellGroup}>
                <span>Shu/Art
                </span> 
               
              </div>
              <div className={styles.cellGroup}>
                <input className={styles.inputg} name={`shu_art_k`}type="text" value={ans['shu_art_k'] || ""} onChange={handleChange} />
               
              </div>
            </td>
          </tr>
        </tbody>
        </table>
      </div>

      {/* Second Section */}
      <div className={styles.sec4}>
       <div className={styles.collist}>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Nails :</div>
            <div className={styles.lastcoltext}> <input name={`nails`} type="text" value={ans['nails'] || ""} onChange={handleChange} className={styles.lastbox}/></div>
        </div>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Tongue :</div>
            <div className={styles.lastcoltext}> <input name={`tongue`} type="text"value={ans['tongue'] || ""} onChange={handleChange}  className={styles.lastbox}/></div>
        </div>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Shabda :</div>
            <div className={styles.lastcoltext}> <input name={`shabda`} type="text"value={ans['shabda'] || ""} onChange={handleChange} className={styles.lastbox}/></div>
        </div>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Skin :</div>
            <div className={styles.lastcoltext}> <input name={`skin`} type="text"value={ans['skin'] || ""} onChange={handleChange} className={styles.lastbox}/></div>
        </div>
       </div>
       <div className={styles.collist}>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Eyes :</div>
            <div className={styles.lastcoltext}> <input name={`eyes`}type="text" value={ans['eyes'] || ""} onChange={handleChange} className={styles.lastbox}/></div>
        </div>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Urine :</div>
            <div className={styles.lastcoltext}> <input name={`urine`}type="text" value={ans['urine'] || ""} onChange={handleChange} className={styles.lastbox}/></div>
        </div>
        <div className={styles.colset}>
            <div className={styles.lastcolname}>Stool :</div>
            <div className={styles.lastcoltext}> <input name={`stool`}type="text" value={ans['stool'] || ""} onChange={handleChange} className={styles.lastbox}/></div>
        </div>
      
       </div>
      </div>
    </div>
  );
};

export default Nadi;
